/**
 * Custom order talep formu — gönderim ve istemci tarafı doğrulama.
 *
 * Neden JS ile gönderiliyor: form Shopify'a değil kendi endpoint'imize gidiyor
 * (Shopify'ın contact formu dosya taşıyamıyor). Düz POST olsaydı tarayıcı sayfadan
 * çıkıp ham JSON gösterirdi. fetch ile sayfada kalıyoruz.
 *
 * Ürün + adet eşleşmesi burada kuruluyor: her seçili ürün için `items` alanına
 * "Etiket|adet" yazılır. Worker son "|" işaretinden bölerek okur. Bu eşleştirmenin
 * tek yerde olması bilinçli — iki tarafta ayrı slug kuralı yazmak, noktalama içeren
 * etiketlerde adedi hata vermeden 1'e düşürüyordu.
 */
(function () {
  'use strict';

  var MAX_FILES = 3;
  var MAX_BYTES = 10 * 1024 * 1024;
  var OK_TYPES = [
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/heic',
    'image/gif',
    'application/pdf',
    'image/svg+xml',
  ];

  function t(el, key, fallback) {
    var v = el.getAttribute('data-msg-' + key);
    return v || fallback;
  }

  function initForm(form) {
    var endpoint = form.getAttribute('data-endpoint');
    if (!endpoint) return;

    var msgEl = form.querySelector('[data-cof-message]');
    var submitBtn = form.querySelector('[data-cof-submit]');
    var submitLabel = form.querySelector('[data-cof-submit-label]');
    var fileInput = form.querySelector('[data-cof-files]');
    var fileList = form.querySelector('[data-cof-filelist]');
    var successEl = form.parentNode.querySelector('[data-cof-success]');
    var refEl = successEl ? successEl.querySelector('[data-cof-ref]') : null;
    var busy = false;

    /* Ürün seçilince adet kutusu açılır. `disabled` bilerek: kapalıyken
       klavyeyle sekmelenmesin ve yanlışlıkla doldurulmasın. */
    form.querySelectorAll('[data-cof-option]').forEach(function (box) {
      var li = box.closest('.aycan-cof__option');
      var wrap = li.querySelector('[data-cof-qty]');
      var input = wrap ? wrap.querySelector('[data-cof-qty-input]') : null;
      var otherWrap = li.querySelector('[data-cof-other]');
      var otherInput = otherWrap ? otherWrap.querySelector('[data-cof-other-input]') : null;
      var isOtherTrigger = box.hasAttribute('data-cof-other-trigger');
      box.addEventListener('change', function () {
        if (wrap && input) {
          wrap.hidden = !box.checked;
          input.disabled = !box.checked;
          if (box.checked) input.value = input.value || '1';
        }
        if (otherWrap && otherInput) {
          otherWrap.hidden = !box.checked;
          otherInput.disabled = !box.checked;
          /* Odağı yalnızca kullanıcı BİZZAT işaretlediğinde alana taşı — alan az
             önce ekrana geldi, klavye kullanıcısı zaten oradan devam edecek
             (GOV.UK conditional-reveal deseni: tetikleyicinin hemen ardında
             DOM'da durduğu için ekran okuyucu sırası bozulmuyor, odağı elle
             taşımak yalnızca akışı hızlandırıyor). */
          if (box.checked && isOtherTrigger) otherInput.focus();
        }
      });
    });

    function showMessage(text, isError) {
      if (!msgEl) return;
      msgEl.textContent = text;
      msgEl.hidden = !text;
      msgEl.classList.toggle('is-error', !!isError);
    }

    var emptyEl = form.querySelector('[data-cof-empty]');

    function renderFiles() {
      if (!fileList || !fileInput) return;
      fileList.innerHTML = '';
      var files = Array.prototype.slice.call(fileInput.files || []);
      files.forEach(function (f) {
        var li = document.createElement('li');
        li.className = 'aycan-cof__fileitem';
        li.textContent = f.name + ' · ' + Math.max(1, Math.round(f.size / 1024)) + ' KB';
        fileList.appendChild(li);
      });
      // "Henüz dosya yok" metni yalnızca hiç dosya yokken. Ham girdinin tarayıcı
      // dilinde bastığı "Dosya seçilmedi"nin yerini alır — bu bizim, çevrilebilir.
      if (emptyEl) emptyEl.hidden = files.length > 0;
    }

    /** Sunucudaki kurallarla AYNI kontroller — kullanıcı hatayı beklemeden görsün. */
    function validateFiles() {
      var files = Array.prototype.slice.call((fileInput && fileInput.files) || []);
      if (files.length === 0) return t(form, 'photo', 'Please add at least one photo.');
      if (files.length > MAX_FILES) return t(form, 'count', 'You can add up to 3 files.');
      for (var i = 0; i < files.length; i++) {
        if (OK_TYPES.indexOf(files[i].type) === -1) {
          return t(form, 'type', 'That file type is not supported.');
        }
        if (files[i].size > MAX_BYTES) {
          return t(form, 'size', 'Each file must be under 10 MB.');
        }
      }
      return null;
    }

    if (fileInput) fileInput.addEventListener('change', function () {
      renderFiles();
      var err = validateFiles();
      showMessage(err || '', !!err);
    });

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (busy) return;

      var email = (form.querySelector('[name="email"]') || {}).value || '';
      if (!/^[^@\s]+@[^@\s.]+\.[^@\s]{2,}$/.test(email.trim())) {
        showMessage(t(form, 'email', 'Please enter a valid email address.'), true);
        return;
      }

      var details = (form.querySelector('[name="details"]') || {}).value || '';
      if (!details.trim()) {
        showMessage(t(form, 'details', 'Please tell me what you would like made.'), true);
        return;
      }

      var chosen = form.querySelectorAll('[data-cof-option]:checked');
      if (chosen.length === 0) {
        showMessage(t(form, 'products', 'Please choose at least one product.'), true);
        return;
      }

      /* "Something else" işaretliyken tarif boşsa gönderilmiyor — "3 adet NE?"
         diye bir siparişin worker/e-posta tarafında oluşmasını baştan önlüyor. */
      var otherErr = null;
      Array.prototype.forEach.call(chosen, function (box) {
        if (otherErr || !box.hasAttribute('data-cof-other-trigger')) return;
        var li = box.closest('.aycan-cof__option');
        var otherInput = li ? li.querySelector('[data-cof-other-input]') : null;
        if (otherInput && !otherInput.value.trim()) otherErr = otherInput;
      });
      if (otherErr) {
        showMessage(t(form, 'other', 'Please tell us what it is.'), true);
        otherErr.focus();
        return;
      }

      var fileErr = validateFiles();
      if (fileErr) {
        showMessage(fileErr, true);
        return;
      }

      var data = new FormData(form);
      // Ürün + adet tek alanda: "Etiket|adet". "Something else" tarifi worker'da
      // ayrı bir alan gerektirmesin diye ETİKETİN İÇİNE gömülüyor — "Something
      // else: küçük bir çanta" gibi; Worker zaten etiketi olduğu gibi başlığa yazıyor.
      Array.prototype.forEach.call(chosen, function (box) {
        var li = box.closest('.aycan-cof__option');
        var qtyInput = li ? li.querySelector('[data-cof-qty-input]') : null;
        var qty = qtyInput && qtyInput.value ? qtyInput.value : '1';
        var label = box.value;
        if (box.hasAttribute('data-cof-other-trigger')) {
          var otherInput = li ? li.querySelector('[data-cof-other-input]') : null;
          var otherText = otherInput && otherInput.value.trim();
          if (otherText) label = label + ': ' + otherText;
        }
        data.append('items', label + '|' + qty);
      });

      busy = true;
      if (submitBtn) submitBtn.disabled = true;
      if (submitLabel) submitLabel.textContent = t(form, 'sending', 'Sending…');
      showMessage('', false);

      fetch(endpoint, { method: 'POST', body: data })
        .then(function (r) {
          return r.json().catch(function () {
            return { ok: false };
          });
        })
        .then(function (res) {
          if (res && res.ok) {
            if (successEl) {
              form.hidden = true;
              successEl.hidden = false;
              if (refEl && res.reference) {
                refEl.textContent = t(form, 'ref', 'Reference') + ': ' + res.reference;
              }
              successEl.focus();
            }
            return;
          }
          /* Sunucu hata kodları -> kullanıcı diline. Bilinmeyen kod olursa genel
             mesaj + yedek e-posta: talep kaybolmasın, kullanıcı ne yapacağını bilsin. */
          var map = {
            invalid_email: 'email',
            photo_required: 'photo',
            too_many_files: 'count',
            unsupported_type: 'type',
            file_too_large: 'size',
          };
          var key = map[res && res.error];
          showMessage(key ? t(form, key, 'Please check the form.') : t(form, 'generic', 'Something went wrong. Please email us instead.'), true);
        })
        .catch(function () {
          showMessage(t(form, 'generic', 'Something went wrong. Please email us instead.'), true);
        })
        .then(function () {
          busy = false;
          if (submitBtn) submitBtn.disabled = false;
          if (submitLabel) submitLabel.textContent = t(form, 'submit', 'Send request');
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-cof-form]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Tema editöründe section yeniden yüklenince tekrar bağlan.
  document.addEventListener('shopify:section:load', boot);
})();
